<template>
  <transition name="sg-alert-fade">
    <div
      v-show="visible"
      :class="[
        ns.b(),
        ns.m(type),
        ns.is('center', center),
        ns.is(theme),
        ns.is('description', isDescription)
      ]"
      role="alert"
    >
      <sg-icon
        v-if="showIcon && iconComponent"
        :class="[ns.e('icon')]"
      >
        <component :is="iconComponent" />
      </sg-icon>
      <div :class="ns.e('content')">
        <div
          v-if="title || $slots.title"
          :class="[ns.e('title')]"
        >
          <slot name="title">{{ title }}</slot>
        </div>
        <div v-if="isDescription" :class="ns.e('description')">
          <slot>
            {{ description }}
          </slot>
        </div>
        <template v-if="closable">
          <div
            v-if="closeText"
            :class="[ns.e('closebtn'), ns.is('customed')]"
            @click="close"
          >
            {{ closeText }}
          </div>
          <sg-icon v-else :class="ns.e('closebtn')" @click="close">
            <Close />
          </sg-icon>
        </template>
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { SgIcon } from '@sgui-plus/components/icon'
import { TypeComponents, TypeComponentsMap } from '@sgui-plus/utils/icon'
import { useNamespace } from '@sgui-plus/hooks'
import { alertProps, alertEmits } from './alert'

export default defineComponent({
  name: 'SgAlert',

  components: {
    SgIcon,
    ...TypeComponents,
  },

  props: alertProps,
  emits: alertEmits,

  setup(props, { emit, slots }) {
    const ns = useNamespace('alert')

    // state
    const visible = ref(true)

    // computed
    const iconComponent = computed(
      () => TypeComponentsMap[props.type] || TypeComponentsMap['info']
    )
    // const isBigIcon = computed(() =>
    //   props.description || slots.default ? ns.is('big') : ''
    // )
    // const isBoldTitle = computed(() =>
    //   props.description || slots.default ? ns.is('bold') : ''
    // )
    const isDescription = computed(() => !!props.description || !!slots.default)

    // methods
    const close = (evt: MouseEvent) => {
      visible.value = false
      emit('onClose', evt)
    }

    return {
      ns,
      visible,
      iconComponent,
      // isBigIcon,
      // isBoldTitle,
      isDescription,
      close,
    }
  },
})
</script>
